import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { FallbackImage, theme } from '@sg/garnish';

import { BUNDLE_HERO_ASPECT_RATIO } from '../../Bundle.constants';

const BundleHeroFallbackImage = require('../../bundle-hero-fallback.webp');

// ─────────────────────────────────────────────────────────────────────────────

export const BundleHero = (props: Props) => {
  const { imageUrl, imageA11y } = props;

  const { formatMessage } = useIntl();

  return (
    <FallbackImage
      aria-label={imageA11y ?? formatMessage(messages.fallbackImageA11y)}
      baseUrl={imageUrl}
      defaultImage={BundleHeroFallbackImage}
      style={styles.hero}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  hero: {
    width: '100%',
    aspectRatio: BUNDLE_HERO_ASPECT_RATIO,
    backgroundColor: theme.colors.KALE,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  fallbackImageA11y: {
    defaultMessage: 'An assortment of sweetgreen plates',
    description: 'Bundle | Hero | Fallback image accessibility label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  imageUrl?: string;
  imageA11y?: string;
};
